import React from 'react'
import {SubHeader, ContactForm, Badge} from '../'

import './contactUs.css'

const ContactUs = () => {
    
  return (
    <>
      <div id='contact-us' className='contact-us-wrapper'>
        <Badge title="Contact" />
        <SubHeader title="We'd love to Hear From You." description="Call Today: +1 4694340425" />

        <div className='contact-us-container'>
          <div className='contact-us-form-cover'>
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUs